import {createAsyncThunk} from '@reduxjs/toolkit'
import {fetchCleaner} from 'sr/utils/api/fetchCleaner'
export const fetchCleanerData = createAsyncThunk(
  'cleaner/fetchCleanerData',
  async (payload: any) => {
    const response = await fetchCleaner({...payload, limit: 10000, select: 'first_name,last_name'})
    const data: {cleaner_name: string; id: string}[] = []
    const idNameMap: {[key: string]: string} = {}
    response.data.forEach((cleaner: any) => {
      idNameMap[cleaner.id || cleaner._id] = `${cleaner.first_name} ${cleaner.last_name}`
      data.push({
        cleaner_name: `${cleaner.first_name} ${cleaner.last_name}`,
        id: cleaner.id || cleaner._id,
      })
    })
    return {
      data,
      idNameMap,
    }
  },
  {
    condition: (_payload, { getState }) => {
      const { cleaner } = getState() as { cleaner: { status: string } }
      return cleaner.status !== 'succeeded' && cleaner.status !== 'loading'
    },
  }
)
